import type { CreateConfigValues } from "@ligament/adapter-utils";

/**
 * Build Bedrock adapter config from the create-agent form values.
 * Uses IAM role auth (no API key needed).
 */
export function buildBedrockConfig(v: CreateConfigValues): Record<string, unknown> {
  const ac: Record<string, unknown> = {};
  // Extra fields beyond standard CreateConfigValues are passed via the form's
  // values bag as arbitrary keys. Cast through unknown for type safety.
  const ext = v as unknown as Record<string, unknown>;

  if (v.model) {
    ac.modelId = v.model;
    ac.model = v.model; // Also store as 'model' for UI compatibility
  }

  // Region — default comes from environment, but allow override
  if (ext.region) {
    ac.region = ext.region;
  }

  // Max tokens
  if (ext.maxTokens) {
    ac.maxTokens = Number(ext.maxTokens);
  }

  // Temperature
  if (ext.temperature !== undefined) {
    ac.temperature = Number(ext.temperature);
  }

  // Guardrail config
  if (ext.guardrailId) {
    ac.guardrailId = ext.guardrailId;
    if (ext.guardrailVersion) {
      ac.guardrailVersion = ext.guardrailVersion;
    }
  }

  // System prompt
  if (v.promptTemplate) ac.systemPrompt = v.promptTemplate;

  // Timeouts and limits
  ac.timeoutSec = 300;
  ac.maxTurnsPerRun = v.maxTurnsPerRun ?? 20;

  return ac;
}
